// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2U_yN","title":"styles_title__3LbWz"};